// extracted by mini-css-extract-plugin
export default {"button":"SendFeedback_button__6k9O9"};